import { Card } from "@/components/ui/card";
import {
  DataTable,
  DateField,
  List,
  ListActions,
  NeutralBadge,
  NumberField,
} from "../../common";
import { ProcessPayrollButton } from "./ProcessPayrollButton";

export const PayrollRunList = () => (
  <List
    title="Payroll"
    actions={<ListActions label="Create Run" />}
    sort={{ field: "period_month", order: "DESC" }}
  >
    <Card className="border border-border rounded-xl bg-card shadow-sm overflow-hidden">
      <DataTable rowClick="show">
        <DataTable.Col source="period_month" label="Month">
          <DateField source="period_month" />
        </DataTable.Col>
        <DataTable.Col label="Status">
          <NeutralBadge />
        </DataTable.Col>
        <DataTable.Col source="employee_count" label="Employees">
          <NumberField source="employee_count" />
        </DataTable.Col>
        <DataTable.Col source="total_gross" label="Gross">
          <NumberField
            source="total_gross"
            options={{ style: "currency", currency: "INR" }}
          />
        </DataTable.Col>
        <DataTable.Col source="total_net" label="Net" className="text-emerald-600 font-semibold" />
        <DataTable.Col label="Action">
          <ProcessPayrollButton />
        </DataTable.Col>
      </DataTable>
    </Card>
  </List>
);

